import { Component, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CommercialImpactItem } from '../../../viewmodels/commercial-impacts/commercial-impact-item';
import { CommercialImpactItemType, CommercialImpactsService } from '../commercial-impacts.service';

@Component({
  selector: 'hb-commercial-impact-item',
  templateUrl: './commercial-impact-item.component.html',
  styleUrls: ['./commercial-impact-item.component.scss'],
})
export class CommercialImpactItemComponent {
  @Input() form: NgForm;
  @Input() isProduction: boolean;
  @Input() itemType: CommercialImpactItemType;
  @Input() isReadOnly: boolean;

  get item(): CommercialImpactItem {
    return this.commercialImpactsService.getCommercialImpactItem(this.itemType);
  }

  constructor(private commercialImpactsService: CommercialImpactsService) {}

  getTotalCostsSum() {
    return this.commercialImpactsService.calculateCurrentItemTotal(this.itemType);
  }
}
